import React from 'react';

export const Progress = ({ value, className = "", ...props }) => {
  return (
    <div
      className={`relative h-2 w-full overflow-hidden rounded-full bg-gray-700 ${className}`}
      {...props}
    >
      <div
        className="h-full bg-gradient-to-r from-rose-500 to-pink-500 transition-all duration-300 ease-out"
        style={{ width: `${Math.min(Math.max(value || 0, 0), 100)}%` }}
      />
    </div>
  );
};